import React, { useEffect, useMemo, useState } from 'react';

export const VERTRIEB_PRESENTATION_HTML_PATH = '/enpower-vertrieb.html';
export const VERTRIEB_PRESENTATION_PDF_PATH = '/enpower-vertrieb.pdf';
export const VERTRIEB_PRESENTATION_SLIDE_COUNT = 17;
export const VERTRIEB_PRESENTATION_SLIDE_PATHS = Array.from(
  { length: VERTRIEB_PRESENTATION_SLIDE_COUNT },
  (_, index) => `/enpower-vertrieb-slides/slide_${String(index + 1).padStart(2, '0')}.png`,
);
export const VERTRIEB_LOGO_PATH = '/enpower-logo-transparent.png';
export const VERTRIEB_LOGO_ON_DARK_PATH = '/enpower-logo-transparent-on-dark.png';
const VERTRIEB_ACCENT_ENERGY_NETWORK_PATH = '/solar-bg.jpg';
const VERTRIEB_ACCENT_ROOFTOP_SOLAR_PATH = '/solar-bg.jpg';
const VERTRIEB_ACCENT_SOLAR_FIELD_PATH = '/solar-farm-bg.jpg';
const VERTRIEB_ACCENT_BATTERY_GRID_PATH = '/speicher-hero.png';
const VERTRIEB_ACCENT_PARTNER_NETWORK_PATH = '/solar-farm-bg.jpg';
export const VERTRIEB_ACCENT_IMAGE_PATHS = [
  VERTRIEB_ACCENT_ENERGY_NETWORK_PATH,
  VERTRIEB_ACCENT_ROOFTOP_SOLAR_PATH,
  VERTRIEB_ACCENT_SOLAR_FIELD_PATH,
  VERTRIEB_ACCENT_BATTERY_GRID_PATH,
  VERTRIEB_ACCENT_PARTNER_NETWORK_PATH,
];

const STORAGE_KEY = 'enpower-vertrieb-text-overrides-v1';
const LEGACY_STORAGE_KEY = 'enpower-vertrieb-number-overrides-v1';
const SLIDE_WIDTH = 1280;
const SLIDE_HEIGHT = 720;
const LOGO_ASPECT_RATIO = 1029 / 132;
const INLINE_TEXT_TAGS = new Set(['SPAN', 'STRONG', 'EM', 'BR', 'SMALL']);

export const VERTRIEB_LOGO_FIELDS = [
  { id: 'logo_s01_1', slide: 1, x: 54, y: 53, width: 620, height: 44, background: '#FFFFFF', plaque: false },
  { id: 'logo_s02_1', slide: 2, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s03_1', slide: 3, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s04_1', slide: 4, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s05_1', slide: 5, x: 54, y: 53, width: 136, height: 32, background: '#FFFFFF', plaque: true },
  { id: 'logo_s06_1', slide: 6, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s07_1', slide: 7, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s08_1', slide: 8, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s09_1', slide: 9, x: 54, y: 53, width: 136, height: 32, background: '#FFFFFF', plaque: true },
  { id: 'logo_s10_1', slide: 10, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s11_1', slide: 11, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s12_1', slide: 12, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s13_1', slide: 13, x: 54, y: 53, width: 136, height: 32, background: '#FFFFFF', plaque: true },
  { id: 'logo_s14_1', slide: 14, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s15_1', slide: 15, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s16_1', slide: 16, x: 54, y: 21, width: 105, height: 26, background: '#FFFFFF', plaque: false },
  { id: 'logo_s17_1', slide: 17, x: 54, y: 53, width: 620, height: 44, background: '#FFFFFF', plaque: false },
];

export const VERTRIEB_IMAGE_ACCENTS = [
  {
    id: 'accent_cover_energy_network',
    slide: 1,
    src: VERTRIEB_ACCENT_ENERGY_NETWORK_PATH,
    x: 696,
    y: 218,
    width: 560,
    height: 392,
    opacity: 0.52,
    blendMode: 'normal',
    objectPosition: 'center 58%',
    veil: 'linear-gradient(90deg, rgba(18,42,92,0.72), rgba(18,42,92,0.36) 48%, rgba(18,42,92,0.58))',
  },
  {
    id: 'accent_dvp_rooftop',
    slide: 5,
    src: VERTRIEB_ACCENT_ROOFTOP_SOLAR_PATH,
    x: 244,
    y: 116,
    width: 410,
    height: 360,
    opacity: 0.44,
    blendMode: 'normal',
    objectPosition: 'center 58%',
    veil: 'linear-gradient(180deg, rgba(18,42,92,0.56), rgba(18,42,92,0.22) 48%, rgba(18,42,92,0.62))',
  },
  {
    id: 'accent_ffpv_solar_field',
    slide: 9,
    src: VERTRIEB_ACCENT_SOLAR_FIELD_PATH,
    x: 234,
    y: 118,
    width: 418,
    height: 368,
    opacity: 0.44,
    blendMode: 'normal',
    objectPosition: 'center center',
    veil: 'linear-gradient(180deg, rgba(18,42,92,0.54), rgba(18,42,92,0.18) 48%, rgba(18,42,92,0.64))',
  },
  {
    id: 'accent_bess_grid',
    slide: 13,
    src: VERTRIEB_ACCENT_BATTERY_GRID_PATH,
    x: 246,
    y: 112,
    width: 418,
    height: 372,
    opacity: 0.48,
    blendMode: 'normal',
    objectPosition: '61% 64%',
    veil: 'linear-gradient(180deg, rgba(18,42,92,0.58), rgba(18,42,92,0.2) 46%, rgba(18,42,92,0.66))',
  },
  {
    id: 'accent_contact_partner_network',
    slide: 17,
    src: VERTRIEB_ACCENT_PARTNER_NETWORK_PATH,
    x: 720,
    y: 500,
    width: 540,
    height: 210,
    opacity: 0.24,
    blendMode: 'normal',
    objectPosition: 'center center',
    veil: 'linear-gradient(90deg, rgba(18,42,92,0.68), rgba(18,42,92,0.34) 52%, rgba(18,42,92,0.56))',
  },
];

export const VERTRIEB_NUMBER_FIELDS = [
  { id: 'cover_year_title', slide: 1, label: 'Folie 1: Jahr Titel', value: 'Vertriebspräsentation 2026', x: 86, y: 179, width: 232, height: 18, fontSize: 11, fontWeight: 700, color: '#E07000', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'cover_year_footer', slide: 1, label: 'Folie 1: Jahr rechts', value: '2026', x: 1196, y: 646, width: 42, height: 18, fontSize: 11, fontWeight: 600, color: '#C9D2E5', background: '#122A5C', fontFamily: 'Outfit' },
  { id: 'dvp_min_area_divider', slide: 5, label: 'Folie 5: Dachfläche', value: 'ab 600 m²', x: 728, y: 456, width: 144, height: 44, fontSize: 28, fontWeight: 800, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'dvp_runtime_divider', slide: 5, label: 'Folie 5: Laufzeit', value: '20 J.', x: 990, y: 456, width: 74, height: 44, fontSize: 28, fontWeight: 800, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'dvp_min_area_model', slide: 6, label: 'Folie 6: Dachfläche', value: 'ab 600 m²', x: 76, y: 431, width: 106, height: 32, fontSize: 20, fontWeight: 700, color: '#122A5C', background: '#F8FAFC', fontFamily: 'Outfit' },
  { id: 'dvp_partner_experience', slide: 6, label: 'Folie 6: Erfahrung', value: '20+ Jahre Erfahrung', x: 866, y: 412, width: 210, height: 32, fontSize: 20, fontWeight: 700, color: '#122A5C', background: '#F8FAFC', fontFamily: 'Outfit' },
  { id: 'dvp_runtime_conditions', slide: 7, label: 'Folie 7: Vertragsdauer', value: '20 Jahre, optional 2× 5 Jahre Verlängerung', x: 186, y: 243, width: 220, height: 24, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'dvp_min_area_conditions', slide: 7, label: 'Folie 7: Mindestgröße', value: 'ab ca. 500 m² zusammenhängend', x: 576, y: 243, width: 226, height: 24, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'dvp_pacht_range', slide: 7, label: 'Folie 7: Pacht pro kWp', value: '160 € – 200 €', x: 968, y: 273, width: 96, height: 24, fontSize: 13, fontWeight: 700, color: '#FFB066', background: '#122A5C', fontFamily: 'Manrope' },
  { id: 'dvp_area_kwp', slide: 7, label: 'Folie 7: Fläche zu kWp', value: '2.000 m² ≈ 400 kWp', x: 879, y: 302, width: 135, height: 24, fontSize: 13, fontWeight: 400, color: '#E5ECF8', background: '#122A5C', fontFamily: 'Manrope' },
  { id: 'dvp_example_formula', slide: 7, label: 'Folie 7: Formel', value: '400 kWp × 200 €', x: 882, y: 419, width: 122, height: 24, fontSize: 13, fontWeight: 400, color: '#C9D2E5', background: '#1E3768', fontFamily: 'Outfit' },
  { id: 'dvp_example_total', slide: 7, label: 'Folie 7: Beispielrechnung', value: '80.000 €', x: 1010, y: 392, width: 178, height: 58, fontSize: 38, fontWeight: 800, color: '#FFB066', background: '#1E3768', fontFamily: 'Outfit' },
  { id: 'dvp_project_size_tag', slide: 8, label: 'Folie 8: Tag Projektgröße', value: 'DVP · 250 kWp', x: 1096, y: 106, width: 104, height: 22, fontSize: 11, fontWeight: 700, color: '#E07000', background: '#FFF3E8', fontFamily: 'Outfit' },
  { id: 'dvp_project_size', slide: 8, label: 'Folie 8: Projektgröße', value: '250 kWp', x: 1120, y: 157, width: 72, height: 24, fontSize: 14, fontWeight: 700, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'dvp_max_budget', slide: 8, label: 'Folie 8: Pachtspielraum', value: '230 € / kWp', x: 1120, y: 189, width: 94, height: 24, fontSize: 14, fontWeight: 700, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'dvp_owner_lease', slide: 8, label: 'Folie 8: Eigentümerpacht', value: '180 € / kWp', x: 1120, y: 220, width: 94, height: 24, fontSize: 14, fontWeight: 700, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'dvp_difference', slide: 8, label: 'Folie 8: Differenz', value: '50 € / kWp', x: 1120, y: 252, width: 86, height: 24, fontSize: 14, fontWeight: 700, color: '#E07000', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'dvp_provision_formula', slide: 8, label: 'Folie 8: Provisionsformel', value: '50 € × 250 kWp', x: 684, y: 352, width: 112, height: 24, fontSize: 13, fontWeight: 400, color: '#C9D2E5', background: '#122A5C', fontFamily: 'Outfit' },
  { id: 'dvp_provision_total', slide: 8, label: 'Folie 8: Provision', value: '12.500 €', x: 1024, y: 325, width: 164, height: 58, fontSize: 38, fontWeight: 800, color: '#FFB066', background: '#122A5C', fontFamily: 'Outfit' },
  { id: 'ffpv_min_area_divider', slide: 9, label: 'Folie 9: Mindestfläche', value: 'ab 1 ha', x: 728, y: 456, width: 100, height: 44, fontSize: 28, fontWeight: 800, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'ffpv_runtime_divider', slide: 9, label: 'Folie 9: Laufzeit', value: '30 J.', x: 990, y: 456, width: 74, height: 44, fontSize: 28, fontWeight: 800, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'ffpv_headline_runtime', slide: 10, label: 'Folie 10: Headline Laufzeit', value: 'Stabile Einnahmen über 30 Jahre — ohne eigenen Aufwand.', x: 54, y: 108, width: 610, height: 58, fontSize: 38, fontWeight: 700, color: '#0E214A', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'ffpv_benefit_runtime', slide: 10, label: 'Folie 10: Vorteil Laufzeit', value: 'Planbare Einnahmen für 30 Jahre', x: 790, y: 147, width: 210, height: 24, fontSize: 13, fontWeight: 400, color: '#E5ECF8', background: '#122A5C', fontFamily: 'Manrope' },
  { id: 'ffpv_min_area_model', slide: 10, label: 'Folie 10: Mindestfläche', value: 'ab 1 ha', x: 76, y: 412, width: 82, height: 32, fontSize: 20, fontWeight: 700, color: '#122A5C', background: '#F8FAFC', fontFamily: 'Outfit' },
  { id: 'ffpv_runtime_conditions', slide: 11, label: 'Folie 11: Vertragsdauer', value: '30 Jahre, Verlängerungsoption möglich', x: 186, y: 243, width: 210, height: 24, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'ffpv_lease_range', slide: 11, label: 'Folie 11: Pachtzahlung', value: 'jährlich, indexiert (üblich 4.000 – 5.000 € pro ha / Jahr)', x: 183, y: 292, width: 225, height: 24, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'ffpv_example_area', slide: 11, label: 'Folie 11: Beispiel Fläche', value: '10 ha Fläche', x: 889, y: 429, width: 88, height: 24, fontSize: 13, fontWeight: 400, color: '#C9D2E5', background: '#1E3768', fontFamily: 'Outfit' },
  { id: 'ffpv_example_total', slide: 11, label: 'Folie 11: Beispiel Ergebnis', value: '40 – 50.000 €', x: 982, y: 411, width: 172, height: 40, fontSize: 24, fontWeight: 800, color: '#FFB066', background: '#1E3768', fontFamily: 'Outfit' },
  { id: 'ffpv_contract_payment', slide: 12, label: 'Folie 12: Vertragsschluss Provision', value: '650 €', x: 818, y: 138, width: 56, height: 26, fontSize: 15, fontWeight: 800, color: '#E07000', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'ffpv_build_payment', slide: 12, label: 'Folie 12: Bau Provision', value: '650 €', x: 818, y: 191, width: 56, height: 26, fontSize: 15, fontWeight: 800, color: '#E07000', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'ffpv_build_time', slide: 12, label: 'Folie 12: Bau Zeitraum', value: '2 – 3 Jahre', x: 1010, y: 191, width: 82, height: 26, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'ffpv_total_per_mw', slide: 12, label: 'Folie 12: Gesamt pro MW', value: '1.300 €', x: 1067, y: 264, width: 144, height: 58, fontSize: 38, fontWeight: 800, color: '#FFB066', background: '#122A5C', fontFamily: 'Outfit' },
  { id: 'ffpv_example_project', slide: 12, label: 'Folie 12: Beispielprojekt', value: 'Skaliert linear mit der installierten MW-Leistung. Beispiel: ein 10 MW-Projekt →', x: 648, y: 376, width: 466, height: 24, fontSize: 13, fontWeight: 400, color: '#475569', background: '#F8FAFC', fontFamily: 'Manrope' },
  { id: 'ffpv_example_provision', slide: 12, label: 'Folie 12: Beispielprovision', value: '13.000 €', x: 1096, y: 376, width: 72, height: 24, fontSize: 13, fontWeight: 700, color: '#122A5C', background: '#F8FAFC', fontFamily: 'Manrope' },
  { id: 'bess_min_area_divider', slide: 13, label: 'Folie 13: Grundstücksgröße', value: 'ab 300 m²', x: 728, y: 446, width: 144, height: 44, fontSize: 28, fontWeight: 800, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'bess_runtime_divider', slide: 13, label: 'Folie 13: Laufzeit', value: '20 J.', x: 990, y: 446, width: 74, height: 44, fontSize: 28, fontWeight: 800, color: '#122A5C', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'bess_runtime_conditions', slide: 15, label: 'Folie 15: Vertragsdauer', value: 'i.d.R. 20 Jahre, Verlängerungsoption', x: 186, y: 243, width: 238, height: 24, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'bess_lease_rate', slide: 15, label: 'Folie 15: Pachtzahlung', value: 'Einmal- oder jährliche Zahlung, indexiert (ca. 2.000 € pro 80 m²/Jahr)', x: 183, y: 273, width: 235, height: 24, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'bess_min_area_conditions', slide: 15, label: 'Folie 15: Mindestgröße', value: 'ab 300 m²', x: 963, y: 243, width: 78, height: 24, fontSize: 13, fontWeight: 700, color: '#FFB066', background: '#122A5C', fontFamily: 'Manrope' },
  { id: 'bess_example_area', slide: 15, label: 'Folie 15: Beispiel Fläche', value: '2.000 m² Fläche', x: 889, y: 429, width: 112, height: 24, fontSize: 13, fontWeight: 400, color: '#C9D2E5', background: '#1E3768', fontFamily: 'Outfit' },
  { id: 'bess_example_total', slide: 15, label: 'Folie 15: Beispiel Ergebnis', value: '40 – 50.000 €', x: 982, y: 411, width: 172, height: 40, fontSize: 24, fontWeight: 800, color: '#FFB066', background: '#1E3768', fontFamily: 'Outfit' },
  { id: 'bess_net_request_payment', slide: 16, label: 'Folie 16: Netzanfrage Provision', value: '2.000 €', x: 819, y: 138, width: 72, height: 26, fontSize: 15, fontWeight: 800, color: '#E07000', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'bess_net_request_time', slide: 16, label: 'Folie 16: Netzanfrage Zeitraum', value: 'ca. 4 – 6 Monate', x: 1010, y: 139, width: 118, height: 26, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'bess_permit_payment', slide: 16, label: 'Folie 16: Baugenehmigung Provision', value: '6.500 €', x: 819, y: 191, width: 72, height: 26, fontSize: 15, fontWeight: 800, color: '#E07000', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'bess_permit_time', slide: 16, label: 'Folie 16: Baugenehmigung Zeitraum', value: 'ca. 6 – 12 Monate', x: 1010, y: 191, width: 124, height: 26, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'bess_build_payment', slide: 16, label: 'Folie 16: Bau Provision', value: '10.000 €', x: 819, y: 243, width: 82, height: 26, fontSize: 15, fontWeight: 800, color: '#E07000', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'bess_build_time', slide: 16, label: 'Folie 16: Bau Zeitraum', value: 'ca. 12 – 18 Monate', x: 1010, y: 243, width: 130, height: 26, fontSize: 13, fontWeight: 400, color: '#0B1220', background: '#FFFFFF', fontFamily: 'Manrope' },
  { id: 'bess_max_provision', slide: 16, label: 'Folie 16: Maximale Provision', value: '18.500 €', x: 1046, y: 316, width: 166, height: 58, fontSize: 38, fontWeight: 800, color: '#FFB066', background: '#122A5C', fontFamily: 'Outfit' },
  { id: 'contact_year', slide: 17, label: 'Folie 17: Jahr', value: '2026 · Wir freuen uns auf das Gespräch', x: 54, y: 643, width: 320, height: 22, fontSize: 12, fontWeight: 600, color: '#64748B', background: '#FFFFFF', fontFamily: 'Outfit' },
  { id: 'contact_phone_michael', slide: 17, label: 'Folie 17: Telefon Michael', value: '0151 50730679', x: 790, y: 217, width: 106, height: 24, fontSize: 13, fontWeight: 400, color: '#C9D2E5', background: '#1E3768', fontFamily: 'Manrope' },
  { id: 'contact_phone_randy', slide: 17, label: 'Folie 17: Telefon Randy', value: '0151 50730679', x: 790, y: 386, width: 106, height: 24, fontSize: 13, fontWeight: 400, color: '#C9D2E5', background: '#1E3768', fontFamily: 'Manrope' },
];

const readStoredValues = (storageKey) => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    return JSON.parse(window.localStorage.getItem(storageKey) || '{}');
  } catch {
    return {};
  }
};

const getInitialValues = (fields) => {
  const defaultValues = Object.fromEntries(fields.map((field) => [field.id, field.value]));

  if (typeof window === 'undefined') {
    return defaultValues;
  }

  return {
    ...defaultValues,
    ...readStoredValues(LEGACY_STORAGE_KEY),
    ...readStoredValues(STORAGE_KEY),
  };
};

const cleanText = (value) => String(value || '')
  .replace(/\u00a0/g, ' ')
  .replace(/\u00ad/g, '')
  .replace(/[ \t]+\n/g, '\n')
  .replace(/\n[ \t]+/g, '\n')
  .replace(/[ \t]{2,}/g, ' ')
  .trim();

const normalizeDeckText = (value) => cleanText(value)
  .replace(/Randy Wesley/g, 'Randy Kirsten')
  .replace(/Liquiditätsfreundlich/g, 'Liquiditätsfreundlich');

const slugify = (value) => cleanText(value)
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_|_$/g, '')
  .slice(0, 34) || 'text';

const parseCssColor = (color) => {
  if (!color || color === 'transparent') {
    return null;
  }

  const rgbaMatch = color.match(/rgba?\(([^)]+)\)/i);

  if (rgbaMatch) {
    const parts = rgbaMatch[1].split(',').map((part) => Number.parseFloat(part.trim()));
    return {
      r: parts[0],
      g: parts[1],
      b: parts[2],
      a: parts.length > 3 ? parts[3] : 1,
    };
  }

  const hexMatch = color.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);

  if (hexMatch) {
    const hex = hexMatch[1].length === 3
      ? hexMatch[1].split('').map((part) => `${part}${part}`).join('')
      : hexMatch[1];

    return {
      r: Number.parseInt(hex.slice(0, 2), 16),
      g: Number.parseInt(hex.slice(2, 4), 16),
      b: Number.parseInt(hex.slice(4, 6), 16),
      a: 1,
    };
  }

  return null;
};

const blendColor = (foreground, background) => ({
  r: Math.round((foreground.r * foreground.a) + (background.r * (1 - foreground.a))),
  g: Math.round((foreground.g * foreground.a) + (background.g * (1 - foreground.a))),
  b: Math.round((foreground.b * foreground.a) + (background.b * (1 - foreground.a))),
  a: 1,
});

const formatRgb = (color) => `rgb(${color.r}, ${color.g}, ${color.b})`;

const createReferenceFrame = (html) => new Promise((resolve, reject) => {
  const frame = document.createElement('iframe');
  frame.title = 'ENPOWER Vertrieb Referenzmessung';
  frame.setAttribute('aria-hidden', 'true');
  frame.style.cssText = 'position:absolute;left:-20000px;top:0;width:1400px;height:13000px;border:0;visibility:hidden;pointer-events:none;';
  let isResolved = false;
  let attempts = 0;
  const finish = async () => {
    if (isResolved) {
      return;
    }

    try {
      const referenceDocument = frame.contentDocument;

      if (!referenceDocument?.querySelector('.slide') && attempts < 30) {
        attempts += 1;
        setTimeout(finish, 100);
        return;
      }

      isResolved = true;
      clearTimeout(fallbackTimer);

      if (referenceDocument?.fonts?.ready) {
        await Promise.race([
          referenceDocument.fonts.ready,
          new Promise((resolve) => setTimeout(resolve, 1200)),
        ]);
      }
      setTimeout(() => resolve({ frame, referenceDocument }), 0);
    } catch (error) {
      reject(error);
    }
  };
  const fallbackTimer = setTimeout(finish, 1500);
  frame.onload = finish;
  frame.onerror = reject;
  frame.srcdoc = html;
  document.body.appendChild(frame);
});

const isVisibleElement = (view, element) => {
  const rect = element.getBoundingClientRect();
  const style = view.getComputedStyle(element);
  return rect.width > 2
    && rect.height > 2
    && style.display !== 'none'
    && style.visibility !== 'hidden'
    && Number(style.opacity || 1) > 0.01;
};

const resolveBackground = (view, element, slide) => {
  let currentElement = element;

  while (currentElement && currentElement !== view.document.body) {
    const style = view.getComputedStyle(currentElement);
    const backgroundImage = style.backgroundImage || '';

    if (backgroundImage && backgroundImage !== 'none') {
      if (backgroundImage.includes('224, 112, 0') || backgroundImage.includes('255, 139, 31')) {
        return '#E07000';
      }

      if (backgroundImage.includes('18, 42, 92') || backgroundImage.includes('14, 33, 74') || backgroundImage.includes('27, 58, 126')) {
        return '#122A5C';
      }
    }

    const background = parseCssColor(style.backgroundColor);

    if (background && background.a > 0) {
      if (background.a >= 0.98) {
        return style.backgroundColor;
      }

      const baseColor = parseCssColor(resolveBackground(view, currentElement.parentElement || slide, slide)) || { r: 255, g: 255, b: 255, a: 1 };
      return formatRgb(blendColor(background, baseColor));
    }

    if (currentElement === slide) {
      break;
    }

    currentElement = currentElement.parentElement;
  }

  const textColor = view.getComputedStyle(element).color;
  if (textColor.includes('255, 255, 255') || textColor.includes('201, 210, 229') || textColor.includes('229, 236, 248') || textColor.includes('255, 230, 204')) {
    return '#122A5C';
  }

  return '#FFFFFF';
};

const hasVisibleBlockChild = (view, element) => Array.from(element.children).some((child) => {
  if (child.closest('.wordmark')) {
    return false;
  }

  const childText = cleanText(child.innerText);

  return isVisibleElement(view, child) && childText && !INLINE_TEXT_TAGS.has(child.tagName);
});

const shouldSkipTextField = (field) => {
  const compactValue = cleanText(field.value).replace(/\s+/g, '');

  if (/^[1-5]$/.test(compactValue) && field.width <= 50 && field.height <= 50) {
    return true;
  }

  if (/^\d{2}$/.test(compactValue) && field.fontSize >= 80) {
    return true;
  }

  return false;
};

const extractReferenceFields = async () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return { textFields: VERTRIEB_NUMBER_FIELDS, logoFields: VERTRIEB_LOGO_FIELDS };
  }

  const response = await fetch(VERTRIEB_PRESENTATION_HTML_PATH, { cache: 'no-store' });

  if (!response.ok) {
    throw new Error('Referenzpräsentation konnte nicht geladen werden.');
  }

  const html = await response.text();
  const { frame, referenceDocument } = await createReferenceFrame(html);

  try {
    const view = referenceDocument.defaultView;
    const slides = Array.from(referenceDocument.querySelectorAll('.slide'));
    const textFields = [];
    const logoFields = [];

    slides.forEach((slide, slideIndex) => {
      const slideNumber = slideIndex + 1;
      const slideRect = slide.getBoundingClientRect();

      slide.querySelectorAll('.wordmark').forEach((logo, logoIndex) => {
        if (!isVisibleElement(view, logo)) {
          return;
        }

        const rect = logo.getBoundingClientRect();
        const plaque = logo.classList.contains('on-dark');
        const height = Math.ceil(rect.height + 8);
        const minLogoWidth = Math.ceil(height * LOGO_ASPECT_RATIO);

        logoFields.push({
          id: `logo_s${String(slideNumber).padStart(2, '0')}_${logoIndex + 1}`,
          slide: slideNumber,
          x: Math.max(0, Math.round(rect.left - slideRect.left - 2)),
          y: Math.max(0, Math.round(rect.top - slideRect.top - 3)),
          width: Math.max(Math.ceil(rect.width + 8), minLogoWidth),
          height,
          background: resolveBackground(view, logo, slide),
          plaque,
        });
      });

      const collectTextField = (element) => {
        if (!element || element.nodeType !== 1 || ['SCRIPT', 'STYLE'].includes(element.tagName) || element.closest('.wordmark')) {
          return;
        }

        if (!isVisibleElement(view, element)) {
          return;
        }

        const sourceText = cleanText(element.innerText);
        const text = normalizeDeckText(sourceText);

        if (!text) {
          return;
        }

        if (hasVisibleBlockChild(view, element)) {
          Array.from(element.children).forEach(collectTextField);
          return;
        }

        const rect = element.getBoundingClientRect();
        const style = view.getComputedStyle(element);
        const fontSize = Number.parseFloat(style.fontSize) || 14;
        const lineHeight = Number.parseFloat(style.lineHeight) || Math.round(fontSize * 1.25);
        const field = {
          id: `text_s${String(slideNumber).padStart(2, '0')}_${String(textFields.length + 1).padStart(3, '0')}_${slugify(text)}`,
          slide: slideNumber,
          label: `Folie ${slideNumber}: ${text.slice(0, 60)}`,
          sourceValue: sourceText,
          value: text,
          x: Math.max(0, Math.round(rect.left - slideRect.left - 4)),
          y: Math.max(0, Math.round(rect.top - slideRect.top - 4)),
          width: Math.min(SLIDE_WIDTH, Math.ceil(rect.width + 10)),
          height: Math.min(SLIDE_HEIGHT, Math.ceil(rect.height + 10)),
          fontSize: Math.round(fontSize * 10) / 10,
          lineHeight: Math.round(lineHeight * 10) / 10,
          fontWeight: style.fontWeight,
          color: style.color,
          background: resolveBackground(view, element, slide),
          fontFamily: style.fontFamily.includes('Outfit') ? 'Outfit' : 'Manrope',
          textAlign: style.textAlign,
        };

        if (!shouldSkipTextField(field)) {
          textFields.push(field);
        }
      };

      Array.from(slide.children).forEach(collectTextField);
    });

    return {
      textFields: textFields.length ? textFields : VERTRIEB_NUMBER_FIELDS,
      logoFields: logoFields.length ? logoFields : VERTRIEB_LOGO_FIELDS,
    };
  } finally {
    frame.remove();
  }
};

const getFieldStyle = (field, isDirty) => ({
  left: `${(field.x / SLIDE_WIDTH) * 100}%`,
  top: `${(field.y / SLIDE_HEIGHT) * 100}%`,
  width: `${(field.width / SLIDE_WIDTH) * 100}%`,
  height: `${(field.height / SLIDE_HEIGHT) * 100}%`,
  fontSize: `${field.fontSize}px`,
  fontWeight: field.fontWeight,
  '--vertrieb-field-color': field.color,
  '--vertrieb-field-background': field.background,
  color: isDirty ? field.color : 'transparent',
  background: isDirty ? field.background : 'transparent',
  caretColor: field.color,
  fontFamily: `'${field.fontFamily}', sans-serif`,
  lineHeight: field.lineHeight ? `${field.lineHeight}px` : '1.15',
  textAlign: field.textAlign || 'left',
});

const getLogoStyle = (field) => ({
  left: `${(field.x / SLIDE_WIDTH) * 100}%`,
  top: `${(field.y / SLIDE_HEIGHT) * 100}%`,
  width: `${(Math.max(field.width, Math.ceil(field.height * LOGO_ASPECT_RATIO)) / SLIDE_WIDTH) * 100}%`,
  height: `${(field.height / SLIDE_HEIGHT) * 100}%`,
  background: 'transparent',
  borderRadius: 0,
  padding: 0,
});

const getImageAccentStyle = (accent) => ({
  left: `${(accent.x / SLIDE_WIDTH) * 100}%`,
  top: `${(accent.y / SLIDE_HEIGHT) * 100}%`,
  width: `${(accent.width / SLIDE_WIDTH) * 100}%`,
  height: `${(accent.height / SLIDE_HEIGHT) * 100}%`,
  opacity: accent.opacity,
  mixBlendMode: accent.blendMode || 'normal',
  '--vertrieb-accent-veil': accent.veil || 'transparent',
  '--vertrieb-accent-position': accent.objectPosition || 'center',
});

export const VertriebsPraesentation = ({ readOnly = false }) => {
  const [editableFields, setEditableFields] = useState(VERTRIEB_NUMBER_FIELDS);
  const [logoFields, setLogoFields] = useState(VERTRIEB_LOGO_FIELDS);
  const [fieldValues, setFieldValues] = useState(() => getInitialValues(VERTRIEB_NUMBER_FIELDS));
  const imageAccentsBySlide = useMemo(() => VERTRIEB_IMAGE_ACCENTS.reduce((groups, accent) => {
    const nextGroups = groups;
    nextGroups[accent.slide] = nextGroups[accent.slide] || [];
    nextGroups[accent.slide].push(accent);
    return nextGroups;
  }, {}), []);
  const fieldsBySlide = useMemo(() => editableFields.reduce((groups, field) => {
    const nextGroups = groups;
    nextGroups[field.slide] = nextGroups[field.slide] || [];
    nextGroups[field.slide].push(field);
    return nextGroups;
  }, {}), [editableFields]);
  const logoFieldsBySlide = useMemo(() => logoFields.reduce((groups, field) => {
    const nextGroups = groups;
    nextGroups[field.slide] = nextGroups[field.slide] || [];
    nextGroups[field.slide].push(field);
    return nextGroups;
  }, {}), [logoFields]);

  useEffect(() => {
    let isMounted = true;

    extractReferenceFields()
      .then(({ textFields, logoFields: measuredLogoFields }) => {
        if (!isMounted) {
          return;
        }

        setEditableFields(textFields);
        setLogoFields(measuredLogoFields);
        setFieldValues((currentValues) => ({
          ...getInitialValues(textFields),
          ...currentValues,
        }));
      })
      .catch((error) => {
        console.warn('Vertriebspräsentation konnte nicht vollständig vermessen werden.', error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(fieldValues));
  }, [fieldValues]);

  const handleFieldChange = (fieldId, value) => {
    if (readOnly) {
      return;
    }

    setFieldValues((currentValues) => ({
      ...currentValues,
      [fieldId]: value,
    }));
  };

  return (
    <div className="vertrieb-reference-deck" data-testid="vertrieb-reference-deck">
      {VERTRIEB_PRESENTATION_SLIDE_PATHS.map((slidePath, index) => {
        const slideNumber = index + 1;

        return (
          <figure className="vertrieb-reference-slide" data-testid="vertrieb-reference-slide" key={slidePath}>
            <img
              alt={`EN:POWER Vertriebspräsentation Folie ${slideNumber}`}
              className="vertrieb-reference-slide-image"
              draggable="false"
              loading="eager"
              src={slidePath}
            />
            {(imageAccentsBySlide[slideNumber] || []).map((accent) => (
              <div
                aria-hidden="true"
                className="vertrieb-image-accent"
                data-vertrieb-image-accent="true"
                key={accent.id}
                style={getImageAccentStyle(accent)}
              >
                <img
                  alt=""
                  className="vertrieb-image-accent-image"
                  data-vertrieb-accent-image="true"
                  draggable="false"
                  src={accent.src}
                />
              </div>
            ))}
            {(logoFieldsBySlide[slideNumber] || []).map((field) => (
              <div
                aria-hidden="true"
                className={`vertrieb-logo-overlay${field.plaque ? ' vertrieb-logo-overlay-on-dark' : ''}`}
                data-vertrieb-logo-overlay="true"
                key={field.id}
                style={getLogoStyle(field)}
              >
                <img
                  alt=""
                  className="vertrieb-logo-image"
                  data-vertrieb-logo-image="true"
                  data-vertrieb-logo-variant={field.plaque ? 'on-dark' : 'default'}
                  draggable="false"
                  src={field.plaque ? VERTRIEB_LOGO_ON_DARK_PATH : VERTRIEB_LOGO_PATH}
                />
              </div>
            ))}
            {(fieldsBySlide[slideNumber] || []).map((field) => {
              const currentValue = fieldValues[field.id] ?? field.value;
              const isDirty = currentValue !== (field.sourceValue || field.value);

              return (
                <textarea
                  aria-label={field.label}
                  className="vertrieb-editable-field"
                  data-vertrieb-editable-field="true"
                  data-vertrieb-field-dirty={isDirty ? 'true' : 'false'}
                  data-vertrieb-field-id={field.id}
                  key={field.id}
                  onChange={(event) => handleFieldChange(field.id, event.target.value)}
                  readOnly={readOnly}
                  spellCheck={false}
                  style={getFieldStyle(field, isDirty)}
                  title={field.label}
                  value={currentValue}
                />
              );
            })}
          </figure>
        );
      })}
    </div>
  );
};
